import { useCallback, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { Link } from "react-router-dom";

export function CodeBlock({ value, label }) {
  const [copied, setCopied] = useState(false);
  return (
    <div className="Memos-code">
      {label ? <div className="Memos-codeLabel">{label}</div> : null}
      <div className="Memos-codeRow">
        <code translate="no">{value}</code>
        <button
          type="button"
          onClick={() => {
            navigator.clipboard.writeText(value).then(() => {
              setCopied(true);
              window.setTimeout(() => setCopied(false), 1400);
            });
          }}
        >
          {copied ? "Скопировано" : "Копировать"}
        </button>
      </div>
    </div>
  );
}

function Lightbox({ src, caption, onClose }) {
  useEffect(() => {
    const onKey = (event) => {
      if (event.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = previousOverflow;
    };
  }, [onClose]);

  return createPortal(
    <div className="Memos-lightbox" onClick={onClose} role="presentation">
      <div
        className="Memos-lightboxDialog"
        role="dialog"
        aria-modal="true"
        aria-label={caption || "Изображение"}
        onClick={(event) => event.stopPropagation()}
      >
        <button type="button" className="Memos-lightboxClose" onClick={onClose} aria-label="Закрыть">
          ×
        </button>
        <img src={src} alt={caption || ""} />
        {caption ? <p>{caption}</p> : null}
      </div>
    </div>,
    document.body
  );
}

export function Fig({ n, caption }) {
  const [open, setOpen] = useState(false);
  const close = useCallback(() => setOpen(false), []);
  const src = `/memos/g${String(n).padStart(3, "0")}.jpg`;
  return (
    <figure className="Memos-figure">
      <button type="button" className="Memos-figureBtn" onClick={() => setOpen(true)}>
        <img src={src} alt={caption || ""} loading="lazy" />
      </button>
      {caption ? <figcaption>{caption}</figcaption> : null}
      {open ? <Lightbox src={src} caption={caption} onClose={close} /> : null}
    </figure>
  );
}

export function Figs({ items, cols = 1 }) {
  return (
    <div className={cols === 2 ? "Memos-figures is-2" : "Memos-figures"}>
      {items.map((item) => (
        <Fig key={item.n} n={item.n} caption={item.caption} />
      ))}
    </div>
  );
}

export function GuideMemo({ sections, children }) {
  return (
    <>
      <nav className="Memos-jump" aria-label="Разделы">
        {sections.map((section) => (
          <a key={section.id} href={`#${section.id}`}>
            {section.label}
          </a>
        ))}
      </nav>
      <div className="Memos-page is-single">
        <div className="Memos-article">{children}</div>
      </div>
    </>
  );
}

export function Related({ items }) {
  return (
    <div className="Memos-related">
      {items.map((item) => (
        <Link key={item.to} to={item.to}>
          {item.label}
        </Link>
      ))}
    </div>
  );
}
